export default __webpack_public_path__ + "static/media/audio-thumbnail-icon.55a2e687.svg";